function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var HaitiFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#2E42A5",
      fillRule: "evenodd",
      d: "M0 3v18h24V3H0Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("mask", {
      id: "b",
      width: "24",
      height: "18",
      x: "0",
      y: "3",
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: 'luminance'
      },
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 3v18h24V3H0Z",
        clipRule: "evenodd"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#b)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#E31D1C",
        fillRule: "evenodd",
        d: "M0 12v9h24v-9H0Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M4.5 6h15v12h-15z"
      }), /*#__PURE__*/_jsx("mask", {
        id: "c",
        width: "16",
        height: "12",
        x: "4",
        y: "6",
        maskUnits: "userSpaceOnUse",
        style: {
          maskType: 'luminance'
        },
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M4.5 6h15v12h-15z"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#c)",
        children: [/*#__PURE__*/_jsx("path", {
          fill: "#279E19",
          fillRule: "evenodd",
          d: "M4.5 15.577s3.6-1.595 7.5-1.498c3.9.098 7.5 1.873 7.5 1.873V18h-15v-2.423Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#026A16",
          fillRule: "evenodd",
          d: "M8.558 8.29a.096.096 0 0 0-.005.112c.2.325 1.268 1.915 3.034 1.915 1.713 0 2.974-1.497 3.27-1.883a.103.103 0 0 0-.027-.151c-.224-.143-.832-.483-1.54-.483-.896 0-1.703.383-1.703.383S10.386 7.8 9.621 7.8c-.615 0-.953.352-1.063.49Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#C51918",
          fillRule: "evenodd",
          d: "m11.842 14.11-1.344-.85c-.786.364-1.178 1.083-1.178 2.16l1.04 1.708H13.537l.751-1.709s.293-2.21-.751-2.566l-1.694 1.258Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#0A328C",
          fillRule: "evenodd",
          d: "M8.901 11.724s-2.029.704-2.029 3.303l2.706.535s-.031-1.489.777-2.187l-1.454-1.651Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#FFD018",
          d: "m7.902 10.896.323-.327L12 14.285l-.323.326-3.775-3.715ZM6.722 11.768l.265-.378 4.855 3.694-.266.378-4.854-3.694ZM5.915 13.216l.208-.415 5.516 3.005-.21.416-5.514-3.006Z"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#FECA00",
          fillRule: "evenodd",
          d: "m6.886 15.007 3.63.475-.204.594h-.575l.392.336.884.242v-.578h.774v1.228H10.13l-.636-.892s-.534.617-1.056.617c-.521 0-1.035-.2-1.035-.874v-.468l-.516-.205v-.475Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#0A328C",
          fillRule: "evenodd",
          d: "M14.712 11.584s2.38.844 2.38 3.443l-2.73.534s-.125-1.921-.967-2.62l1.317-1.357Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#FFD018",
          d: "m16.019 10.896-.337-.327-4.067 3.415.336.326 4.068-3.414ZM17.248 11.768l-.277-.378-5.056 3.694v.692l5.333-4.008Z"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#FFD018",
          d: "m18.087 13.217-.214-.417-6.088 2.958.215.417 6.087-2.958Z"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#FECA00",
          fillRule: "evenodd",
          d: "m17.077 15.007-3.782.475.213.594h.6l-.409.336-.92.242v-.578h-.807v1.228h1.727l.663-.892s.556.617 1.1.617c.542 0 1.078-.2 1.078-.874v-.468l.537-.205v-.475Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#FECA00",
          fillRule: "evenodd",
          d: "M11.537 10.018s-.245 1.806-.245 2.54c0 .735.245 4.641.245 4.641h.63v-4.64c0-.614-.37-2.54-.37-2.54h-.26Z",
          clipRule: "evenodd"
        })]
      })]
    })]
  })]
}));
//# sourceMappingURL=Haiti.js.map